import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { brand, contact, nav, primaryCta } from "@/content/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="on-dark border-t border-ivory/10 bg-ink pb-12 pt-20 text-ivory" data-testid="site-footer">
      <div className="wrap">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo variant="stacked" tone="light" />
            <p className="display mt-10 max-w-sm text-[1.9rem] leading-tight">{brand.signature}</p>
          </div>
          <div className="md:col-span-3">
            <p className="label mb-5">Plan du site</p>
            <ul className="space-y-2.5 text-[15px] text-ivory/90">
              <li><Link className="link-u" to="/">Accueil</Link></li>
              {nav.map((n) => <li key={n.to}><Link className="link-u" to={n.to}>{n.label}</Link></li>)}
              <li><Link className="link-u" to="/expertises/creation-site-internet">Création de sites internet</Link></li>
              <li><Link className="link-u" to={primaryCta.to}>Diagnostic digital</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="label mb-5">Contact</p>
            <ul className="space-y-2.5 text-[15px] text-ivory/90">
              <li><a className="link-u" href={`mailto:${contact.email}`} data-track="email_click" data-testid="footer-email">{contact.email}</a></li>
              <li><a className="link-u" href={`tel:${contact.phoneIntl}`} data-track="phone_click" data-testid="footer-phone">{contact.phone}</a></li>
              <li><a className="link-u" href={contact.instagram.url} target="_blank" rel="noopener noreferrer" data-track="instagram_click" data-testid="footer-instagram">Instagram {contact.instagram.handle}</a></li>
              <li>{brand.city} — partout en {brand.area}</li>
            </ul>
            <Link to={primaryCta.to} data-testid="footer-cta" className="mt-8 inline-flex border border-ivory/40 px-5 py-3 text-[15px] font-semibold transition-colors duration-300 hover:bg-ivory hover:text-ink">{primaryCta.label}</Link>
          </div>
        </div>
        <div className="mt-20 h-px bg-ivory/15" />
        <div className="mt-6 flex flex-col gap-3 text-[14px] text-[#B3BAB4] md:flex-row md:items-center md:justify-between">
          <p>© {year} {brand.name} — Sanaa BAJJANA, EI</p>
          <div className="flex flex-wrap gap-5">
            <Link className="link-u" to="/mentions-legales" data-testid="footer-legal">Mentions légales</Link>
            <Link className="link-u" to="/politique-de-confidentialite" data-testid="footer-privacy">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
